import { type ReactElement, type ReactNode, useId } from 'react';

/**
 * A titled block of the dashboard. The heading names the landmark (`aria-labelledby`), so a screen reader can jump from block to block;
 * `tiles` lays figure cards in a responsive grid (2 columns on a phone, 3 on a tablet, 4 on a desktop).
 */
export function DashboardSection({
  title,
  children,
  tiles = false,
  money = false,
  testId,
}: {
  readonly title: string;
  readonly children: ReactNode;
  readonly tiles?: boolean;
  /** The tiles carry amounts in dinars: one per row on a phone (an amount does not fit in half a phone), two from `sm`. */
  readonly money?: boolean;
  readonly testId?: string;
}): ReactElement {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-3" data-testid={testId}>
      <h2 id={headingId} className="font-display text-lg font-bold text-ink">
        {title}
      </h2>
      {tiles ? (
        <div
          className={`grid gap-3 md:grid-cols-3 xl:grid-cols-4 ${money ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-2'}`}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  );
}
